<script lang="ts">
import { SiteId } from '@goodlifeplus/themes'
import { type Component, defineComponent } from 'vue'

import BannerRangersSection from './BannerRangersSection.vue'
import BannerSaintsSection from './BannerSaintsSection.vue'
import BannerSection from './BannerSection.vue'

/**
 * The "Banner" layout provider.
 */
export default defineComponent({
  components: {
    BannerRangersSection,
    BannerSection,
    BannerSaintsSection,
  },
  setup() {
    return {
      SiteId,
    }
  },
}) as Component
</script>

<template>
  <BannerRangersSection v-if="$theme.name === 'rangers'" />
  <BannerSaintsSection v-else-if="$theme.name === 'saints'" />
  <BannerSection v-else />
</template>
